<!-- Section Header -->
<div class="row">
  <div class="d-flex justify-content-between p-2 mb-2 border"
  style="line-height: 1;background-color: #0c4788;">
  <div class="d-flex align-items-center text-white">
    <strong class="me-2">Notification Management</strong> :
    <span class="ms-2">List of Notifications</span>
  </div>
  <span
  class="cursor-pointer me-5"
  style="line-height: 1;background-color: #0c4788;"
  title="Add Notification"
  (click)="CreateUpdateNotification(null)"
  >
  <i  class="fa fa-plus-circle plus-icon fs-2 text-white">
  </i>
  </span>
  </div>
</div>
<!-- Table -->
<div class="table-container">
  <table
    class="table table-bordered table-sm align-middle text-center table-hover"
  >
    <thead class="table-light sticky-top" style="z-index: 10;">
      <tr>
        <th>Notification ID</th>
        <th>Notification Text</th>
        <th>Notification Affected Area</th>
        <th>Notification Material ID</th>
        <th>Notified Material Status</th>
        <th>Notification Severity</th>
        <th>Notification Method</th>
        <th>Require Acknowledgement?</th>
        <th>Notification Status</th>
        <th>Release Date</th>
        <th>Withdrawal Date</th>
        <th>Withdrawal Reason Description</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let notification of notifications"
        (click)="CreateUpdateNotification(notification)"
      >
        <td>{{ notification.Notification_Id }}</td>
        <td>{{ notification.Notification_Description }}</td>
        <td>{{ notification.Notification_Affected_Area_Type_Code }}</td>
        <td>{{ notification.Notification_Material_Id }}</td>
        <td>{{ notification.Notified_Material_Status_Type_Code }}</td>
        <td>{{ notification.Notification_Severity_Type_Code }}</td>
        <td>{{ notification.Notification_Method_Type_Code }}</td>
        <td>{{ notification.Notification_Acknowledgement_Type_Code }}</td>
        <td>{{ notification.NotificationStatusTypeCode ?? 'New' }}</td>
        <td>{{ notification.Notification_Release_Date | date:'longDate' }}</td>
        <td>{{ notification.Notification_Withdrawn_Date | date:'longDate' }}</td>
        <td>{{ notification.Withdrawal_Reason_Description }}</td>
      </tr>
    </tbody>
  </table>
</div>
